<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Marketplace</span>
        <h2>Marketplace onboarding</h2>
        <p>We will guide you through the tenant setup for your marketplace listing.</p>
      </div>
      <div class="hero-panel">
        <div class="step-pill">Step 1 of 1</div>
        <div class="hero-title">Tenant details</div>
        <div class="hero-subtitle">Confirm the info below.</div>
      </div>
    </div>

    <section class="card">
      @switch (currentStep$ | async) {
      @case ('tenantInfo') {
      <app-tenant-info [startingForm]="userForm.get('tenantInfo')?.value" [finalForm]="true" [status]="status"
        (subformInitialized)="subformInitialized('tenantInfo', $event)" (submitForm)="submitForm()"></app-tenant-info>
      }
      }
    </section>
  </div>
</div>